import { ConfigFieldType } from "../api";
import ConfigInputs from "./ConfigInputs";

type Props = {
  fields: ConfigFieldType[]
}

const FormFields = ({ fields }: Props) => {
  return (
    <div className="space-y-5">
       {fields.map((field) => (
        <ConfigInputs key={field.id} field={field} />
      ))}
    </div>
  )
}

export default FormFields;
